import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { uniqueId } from 'lodash'
import { FormattedMessage } from 'react-intl'
import FormatNumber from 'common/utils/number'

// components
import { ParagraphSmallCaps, Paragraph1 } from 'components/Paragraphs'
import ToggleSwitch from 'components/ToggleSwitch'

// hooks
import { useRelationCategories, useRelationTypes, useShowRelation } from 'flow/settings/relations'

const Container = styled.div(({ theme }) => css`
  color: ${theme.blueElectric};
  padding: 30px 40px 0 30px;
  z-index: 1;
  position: relative;
  height: 600px;
  overflow-y:auto;
`)

const TitleCaps = styled(ParagraphSmallCaps)(({ theme }) => css`
  color: ${theme.blueUltraDark};
  opacity: 0.6;
  margin-bottom: 18px;
`)

const Content = styled.div`
  padding-left: 10px;
  padding-bottom: 30px;
`
const TextBlue = styled(Paragraph1)(({ theme }) => css`
  color: ${theme.blueElectric};
`)

const CheckAllContainer = styled.div(({ theme }) => css`
  border-bottom: 1px solid ${theme.blueMediumLight};
  display: flex;
  white-space: nowrap;
  margin-bottom: 12px;
  padding-bottom: 9px;
`)

const Checker = styled(TextBlue)(({ theme }) => css`
  cursor: pointer;
  text-decoration: underline;
  :hover {
    text-decoration: none;
  }
`)

const Separator = styled(TextBlue)`
  margin: 0 5px;
  opacity:0.3;
`

const ListItem = styled.div`
  display: table-row;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 8px;
`
const InputCell = styled.div`
  display: table-cell;
  font-size: 0;
  line-height: 0;
  padding-right: 15px;
`
const Label = styled('label')`
  display: table-cell;
  white-space: nowrap;
  min-width: 140px;
  text-transform: lowercase;
  :first-letter {
    text-transform: uppercase;
  }
`
const Count = styled(TextBlue)`
  display: table-cell;
  opacity:0.4;
  text-align: right;
  padding-left: 10px;
`
const Unit = styled(TextBlue)`
  display: table-cell;
  vertical-align: top;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  opacity:0.4;
  padding-left: 3px;
`

const ListCheckboxes = ({ items, selectedItems, setSelected, values }) => {
  if (!items) return null
  const groupName = uniqueId('group_')

  const checkAll = () => setSelected(items)
  const uncheckAll = () => setSelected([])
  return (
    <>
      <CheckAllContainer>
        <Checker onClick={checkAll}>
          <FormattedMessage id='button-select-all' />
        </Checker>
        <Separator>/</Separator>
        <Checker onClick={uncheckAll}>
          <FormattedMessage id='button-deselect-all' />
        </Checker>
      </CheckAllContainer>
      {
        items.map((itemId, i) => {
          const isChecked = selectedItems.includes(itemId)
          const handleCheck = () => {
            const newSelected = isChecked
              ? selectedItems.filter(selectedId => selectedId !== itemId)
              : [...selectedItems, itemId]
            setSelected(newSelected)
          }

          return (
            <ListItem key={i}>
              <InputCell>
                <input
                  name={groupName}
                  type='checkbox'
                  checked={isChecked}
                  id={itemId}
                  onChange={handleCheck}
                />
              </InputCell>
              <Label htmlFor={itemId}>
                <TextBlue>
                  <FormattedMessage id={`relation-list-${itemId}`} />
                </TextBlue>
              </Label>
              {/*<Count>
                {FormatNumber(values[itemId])}
              </Count>
              <Unit>
                {i === 0 && ' relations'}
              </Unit>*/}
            </ListItem>
          )
        })
      }
    </>
  )
}

const MenuContent = ({ count }) => {
  const [selectedRelationCategories, relationCategories, setRelationCategories] = useRelationCategories()
  const [selectedRelationTypes, relationTypes, setRelationTypes] = useRelationTypes()
  const [showRelations, setShowRelations] = useShowRelation()

  return (
    <Container>
      <TitleCaps>
        <FormattedMessage id='title-show-links' />
      </TitleCaps>
      <Content>
        <ToggleSwitch
          labels={['Off', 'On']}
          onChange={setShowRelations}
          isChecked={showRelations}
        />
      </Content>

      <TitleCaps>
        <FormattedMessage id='title-link-categories' />
      </TitleCaps>
      <Content>
        <ListCheckboxes
          items={relationCategories}
          selectedItems={selectedRelationCategories}
          setSelected={setRelationCategories}
          values={count.categories}
        />
      </Content>

      <TitleCaps>
        <FormattedMessage id='title-link-types' />
      </TitleCaps>
      <Content>
        <ListCheckboxes
          items={relationTypes}
          selectedItems={selectedRelationTypes}
          setSelected={setRelationTypes}
          values={count.types}
        />
      </Content>
    </Container>
  )
}

export default MenuContent
export { TitleCaps }
